var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4166 2H1.58337C0.710345 2 0 2.71066 0 3.58407V20.4159C0 21.2894 0.710345 22 1.58337 22H22.4166C23.2897 22 24 21.2894 24 20.4159V3.58407C24 2.71066 23.2897 2 22.4166 2ZM1.58337 3.35777H22.4166C22.5392 3.35777 22.6428 3.46141 22.6428 3.58406V15.1271L19.0139 10.4677C18.7447 10.122 18.3505 9.91485 17.9325 9.89946C17.5146 9.8838 17.1063 10.0616 16.8122 10.3866L12.1038 15.5925C11.9905 15.7178 11.7389 15.7524 11.5959 15.6624L7.72449 13.2233C7.06111 12.8052 6.09018 12.8483 5.46634 13.3233L1.35717 16.452V3.58406C1.35717 3.46141 1.46077 3.35777 1.58337 3.35777ZM1.58337 20.6422H22.4166C22.5392 20.6422 22.6428 20.5386 22.6428 20.4158V17.336L17.9434 11.3022C17.9175 11.269 17.8945 11.2567 17.8827 11.2562C17.867 11.2569 17.8468 11.2664 17.8186 11.2976L13.1102 16.5035C12.5553 17.1169 11.5725 17.2521 10.8728 16.8112L7.00139 14.3721C6.81944 14.2575 6.45961 14.2734 6.28833 14.4037L1.35717 18.1582V20.4159C1.35717 20.5386 1.46077 20.6422 1.58337 20.6422Z",
    fill: "#000002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4325 9.78703C12.4325 11.113 11.3543 12.1917 10.0289 12.1917C8.70347 12.1917 7.62524 11.1129 7.62524 9.78703C7.62524 8.46112 8.70347 7.38232 10.0289 7.38232C11.3542 7.38232 12.4325 8.46103 12.4325 9.78703ZM11.0754 9.78693C11.0754 9.20961 10.606 8.74 10.0289 8.74C9.45182 8.74 8.98242 9.2097 8.98242 9.78693C8.98242 10.3643 9.45182 10.8339 10.0289 10.8339C10.606 10.8339 11.0754 10.3643 11.0754 9.78693Z",
    fill: "#000002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPicture);
export default __webpack_public_path__ + "static/media/empty-picture.146cb41408d63ee9b0e654215d4d64b8.svg";
export { ForwardRef as ReactComponent };